﻿import config from "../config"
const baseUrl = config.base_url + "ns_drug/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    list: {
        url:  baseUrl + "list",
        type: "post",
    },
    get: {
        url:  baseUrl + "get/{id}",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    remove: {
        url:  baseUrl + "delete",
        type: "get",
    },

}

